/**
 * 存储工具类 (PC端适配版)
 * 提供本地存储的读写操作，支持同步和异步方法
 */
export const Storage = {
  /**
   * 设置存储数据
   * @param {string} key - 存储键名
   * @param {any} data - 要存储的数据
   * @returns {boolean} - 操作是否成功
   */
  set(key, data) {
    if (!key) {
      console.error('Storage set error: key is required')
      return false
    }
    
    try {
      localStorage.setItem(key, JSON.stringify(data))
      return true
    } catch (e) {
      console.error('Storage set error:', e)
      return false
    }
  },
  
  /**
   * 异步设置存储数据
   * @param {string} key - 存储键名
   * @param {any} data - 要存储的数据
   * @returns {Promise<boolean>} - 操作是否成功
   */
  setAsync(key, data) {
    return new Promise((resolve) => {
      if (!key) {
        console.error('Storage setAsync error: key is required')
        resolve(false)
        return
      }
      
      try {
        localStorage.setItem(key, JSON.stringify(data))
        resolve(true)
      } catch (e) {
        console.error('Storage setAsync error:', e)
        resolve(false)
      }
    })
  },
  
  /**
   * 获取存储数据
   * @param {string} key - 存储键名
   * @param {any} defaultValue - 默认值，当获取失败时返回
   * @returns {any} - 获取的数据或默认值
   */
  get(key, defaultValue = null) {
    if (!key) {
      console.error('Storage get error: key is required')
      return defaultValue
    }
    
    try {
      const value = localStorage.getItem(key)
      return (value !== null) ? JSON.parse(value) : defaultValue
    } catch (e) {
      console.error('Storage get error:', e)
      return defaultValue
    }
  },
  
  /**
   * 异步获取存储数据
   * @param {string} key - 存储键名
   * @param {any} defaultValue - 默认值，当获取失败时返回
   * @returns {Promise<any>} - 获取的数据或默认值
   */
  getAsync(key, defaultValue = null) {
    return new Promise((resolve) => {
      if (!key) {
        console.error('Storage getAsync error: key is required')
        resolve(defaultValue)
        return
      }
      
      try {
        const value = localStorage.getItem(key)
        resolve(value !== null ? JSON.parse(value) : defaultValue)
      } catch (e) {
        console.error('Storage getAsync error:', e)
        resolve(defaultValue)
      }
    })
  },
  
  /**
   * 移除存储数据
   * @param {string} key - 存储键名
   * @returns {boolean} - 操作是否成功
   */
  remove(key) {
    if (!key) {
      console.error('Storage remove error: key is required')
      return false
    }
    
    try {
      localStorage.removeItem(key)
      return true
    } catch (e) {
      console.error('Storage remove error:', e)
      return false
    }
  },
  
  /**
   * 清除所有存储数据
   * @returns {boolean} - 操作是否成功
   */
  clear() {
    try {
      localStorage.clear()
      return true
    } catch (e) {
      console.error('Storage clear error:', e)
      return false
    }
  },
  
  /**
   * 获取存储信息
   * @returns {object|null} - 存储信息或null
   */
  info() {
    try {
      // 返回localStorage的统计信息
      const keys = Object.keys(localStorage)
      return {
        keys,
        currentSize: keys.length,
        limitSize: 'unlimited'
      }
    } catch (e) {
      console.error('Storage info error:', e)
      return null
    }
  }
}
